<template>
  <div>
    <div class="view-header">
      <h4>{{ cases.length }} Support Cases</h4>
      <ul>
        <li>
          <router-link
            class="btn btn-primary p-1"
            :to="{
              path: '/crm/create-org-support-case',
              query: { add: 'org-details', org_Id: orgId, ter_Id: ter_Id },
            }"
          >
            <i class="ti ti-plus"></i>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="notes-activity" v-if="cases.length > 0">
      <div class="calls-box" v-for="item in cases" :key="item.id">
        <div class="caller-info">
          <div class="calls-user">
            <div class="opp-icon me-2">
              <i class="ti ti-headphones"></i>
            </div>
            <div>
              <p title="Case number / subject">
                <router-link
                  class="text-teal"
                  :to="{
                    path: '/crm/edit-org-support-case',
                    query: {
                      add: 'org-details',
                      ter_Id: ter_Id,
                      org_Id: orgId,
                      caseId: item.id,
                      for: 'support-cases',
                    },
                  }"
                >
                  {{ item.ticket_number || '—' }} — {{ item.subject || '(no subject)' }}
                </router-link>
              </p>
              <h6 title="Type / Status">{{ item.ticket_type || '—' }} / {{ item.status || '—' }}</h6>
              <p title="Responsible" class="org-title">
                {{ item.responsible_name || '—' }}
              </p>
            </div>
          </div>
          <div class="calls-action">
            <router-link
              class="text-teal"
              :to="{
                path: '/crm/edit-org-support-case',
                query: {
                  add: 'org-details',
                  ter_Id: ter_Id,
                  org_Id: orgId,
                  caseId: item.id,
                  for: 'support-cases',
                },
              }"
            >
              <i class="ti ti-eye"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-muted p-3">No support cases for this organisation.</div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  name: 'OrganisationSupportCases',
  setup() {
    const store = useStore();
    const route = useRoute();
    const orgId = ref(route.query.org_Id || null);
    const ter_Id = ref(route.query.ter_Id || null);
    const listData = ref({});

    const cases = computed(() => {
      const d = listData.value;
      if (Array.isArray(d?.data)) return d.data;
      if (Array.isArray(d)) return d;
      return [];
    });

    const fetchCases = async () => {
      if (!orgId.value) return;
      const data = await store.dispatch('orgSupportCases/fetchOrgSupportCases', {
        organization_id: orgId.value,
        pageSize: 100,
      });
      listData.value = data || {};
    };

    onMounted(fetchCases);

    return { cases, orgId, ter_Id };
  },
};
</script>
